<template>
    <div class="loading-content-container">
        <div v-if="!loaded" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="loaded">
            <csp-desktop-info-card
                :cols="12"
                icon="inticon-autoclaim_billing"
                title="Abrechnung">
                <h2>Rechtsanwalt / Schadendienstleister</h2>
                <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                    no-rows-text="Es sind keine Rechtsanwälte oder Schadendienstleister zugewiesen."
                    :table-fields="serviceProviderModalityTableFields"
                    :table-form="serviceProviderForm"/>

                <h2>Autohaus</h2>
                <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                    :table-fields="carDealerModalityTableFields"
                    :table-form="carDealerForm"/>

                <h2>Gutachter / Sachverständigenorganisation</h2>
                <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                    no-rows-text="Es sind keine Gutachter zugewiesen."
                    :table-fields="serviceProviderModalityTableFields"
                    :table-form="appraiserForm"/>

                <csp-form-group-btn-submit @click="submit()"/>
            </csp-desktop-info-card>
        </b-row>
    </div>
</template>
<script>
    import InvoicingModalityTable from '@desktop/components/invoicingModality/InvoicingModalityTable.vue';
    import InvoicingModalityMixin from '@desktop/components/invoicingModality/InvoicingModalityMixin.vue';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const invoicingModalityRepository = container.getInvoicingModalityRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FirmGroupInvoicingModalities',
        components: {
            'csp-invoicing-modality-table': InvoicingModalityTable,
        },
        mixins: [InvoicingModalityMixin],
        data() {
            const firmGroupId = this.$route.params.firmGroupId;
            return {
                firmGroupId,
            };
        },
        mounted() {
            this.initializeForm();
        },
        methods: {
            /** is called when the component is mounted and after every successful submit */
            initializeForm() {
                this.loaded = false;

                // load info that defines which and how many rows the modality tables have
                invoicingModalityRepository.showFirmGroupStructure(this.firmGroupId).then(
                    (data) => {
                        this.modalityStructure = data.data.attributes;

                        // load data of existing modality entries from database
                        invoicingModalityRepository.showFirmGroupData(this.firmGroupId).then(
                            (data) => {
                                this.modalityData = data.data;

                                this.initializeTables();

                                // load options for invoice recipient select
                                invoicingModalityRepository.showFirmGroupInvoiceRecipientOptions(this.firmGroupId).then(
                                    (data) => {
                                        this.invoiceRecipientOptions = data.data.attributes;

                                        this.loaded = true;
                                    }
                                )
                            }
                        );
                    }
                );
            },
            submit() {
                this.modalityForm.clearValidationErrors();

                invoicingModalityRepository.updateFirmGroup(this.firmGroupId, this.prepareDataForSubmit()).then(
                    () => {
                        flashMessenger.addSuccess('Die Abrechnungsmodalitäten wurden erfolgreich gespeichert.');

                        // reset data attributes where necessary
                        this.resetCommonData();

                        // re-initialize form with fresh data
                        this.initializeForm();
                    },
                    (error) => {
                        this.handleSubmitError(error);
                    }
                );
            },
        },
    }
</script>
